import { createReducer } from "@reduxjs/toolkit";
import { SidebarStateInterface } from "../actions/Sidebar/types";
import { toggleLeft1Panel, toggleRight2Panel } from "actions";

const initialState: SidebarStateInterface = {
    isLeftSideBar1Open: false,
    isRightSideBar2Open: false
};

const sidebar = createReducer(initialState, (builder) => {
    builder
        .addCase(toggleRight2Panel, (state, action) => {
            state.isRightSideBar2Open = action.payload.data;
        })
        .addCase(toggleLeft1Panel, (state, action) => {
            state.isLeftSideBar1Open = action.payload.data;
        })
        .addDefaultCase((state) => state);
});

export default sidebar;
